import i18next from 'i18next';

export default function i18nTranslateValueFromOptions(value, prefixKeyOptions) {
    if (value === undefined || value === null) {
        return '';
    }
    const valueKey = String(value).toLocaleLowerCase();
    const key = `${prefixKeyOptions}.${valueKey}`;
    if (i18next.exists(key)) {
        return i18next.t(key);
    }

    return value;
}
